import React, { Component } from "react";
import './Tabs.css';
import { connect } from 'react-redux'; // Import the connect function from 'react-redux'


class Tabs extends Component {
  state = {
    selected: this.props.selected || 0
  };

  handleChange(index) {
    this.setState({ selected: index });
  }

  render() {
    const selectedClass =
      this.props.pagename === "sidemenubar" ? "sidemenubarselected" : "selected";

    return (
      <>
        <ul className={`${this.props.pagename === "singleproduct" ? "singleproduct-tabcontainer" : "" || this.props.pagename === "profilepage" ? "profiletabs-tabcontainer" : "" || this.props.pagename === "sidemenubar" ? "sidemenubar-container" : ""}`}>
          {React.Children.map(this.props.children, (elem, index) => {
            let style = index === this.state.selected ? selectedClass : "";
            if (elem.props.onClickFunc) {
              return (
                <button
                  key={index}
                  className={`singleproduct-tab-button`}
                  onClick={() => elem.props.onClickFunc()}
                >
                  {elem.props.icon ? elem.props.icon : null}
                  &nbsp;{elem.props.title}
                </button>
              );
            } else {
              return (
                <li
                  key={index}
                  className={`${this.props.pagename === "singleproduct" ? "singleproduct-tabs " : "" } ${this.props.pagename === "profilepage" ? "profilepage-tabs " : "" }${style}`}
                  onClick={() => this.handleChange(index)}
                >
                  {elem.props.icon ? elem.props.icon : null}
                  &nbsp;{elem.props.title}
                </li>
              );
            }
          })}

        </ul>
        <div onClick={this.props.onClick} className={`${this.props.pagename === "singleproduct" || this.props.pagename === "profilepage" ? "singleproduct-content" : "tab-content"}`}>{this.props.children[this.state.selected]}</div>
      </>
    );
  }

}

export default Tabs;
